import { IFilterSettings } from "Domain/Repository/BaseRepository/BaseRepository";

export const SEARCH_SPOTS_REQUEST = 'SEARCH_SPOTS_REQUEST';

export const searchSpotsRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }: IFilterSettings) => ({
    type: SEARCH_SPOTS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
    }
});
